import { HttpLink } from 'apollo-link-http';
import { GRAPHQL_URL } from 'constants/runtimeConfig';

const httpLink = new HttpLink({
  uri: GRAPHQL_URL,
  credentials: 'omit'
});

export default httpLink;
